import { Guid } from "client_legacy/ndaw/guid";

export type GridViewItemUniqueKey = number | string | Guid;

export type GridViewGroupItem<TModel> = {
	uniqueKey: GridViewItemUniqueKey;
	itemKind: GridViewItemKind;
	model: TModel;
};

export function groupGridViewItems<TModel>(
	items: readonly GridViewGroupItem<TModel>[]
): readonly GridViewGroup<TModel>[] {
	const result: GridViewGroup<TModel>[] = [];
	let currentGroup: GridViewGroup<TModel> | undefined;

	for (const item of items) {
		if (!currentGroup || !currentGroup.tryToAdd(item)) {
			currentGroup = new GridViewGroup(item);
			result.push(currentGroup);
		}
	}

	return result;
}

export class GridViewGroup<TModel> {
	private readonly _items: GridViewGroupItem<TModel>[];

	public readonly kind: GridViewItemKind;
	public readonly uniqueKey: GridViewItemUniqueKey;

	public get items(): readonly GridViewGroupItem<TModel>[] {
		return this._items;
	}

	constructor(item: GridViewGroupItem<TModel>) {
		this.uniqueKey = item.uniqueKey;
		this.kind = item.itemKind;
		this._items = [item];
	}

	public tryToAdd(item: GridViewGroupItem<TModel>): boolean {
		if (!this.doesMatch(item)) {
			return false;
		}

		this._items.push(item);

		return true;
	}

	private doesMatch(item: GridViewGroupItem<TModel>): boolean {
		return this.kind === item.itemKind;
	}
}

export enum GridViewItemKind {
	Default = 0,
	Preview = 1
}
